import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    defaultProcessAreaResource,
    ProcessAreaMutationResourceSchema,
    type ProcessAreaResource,
    useProcessAreaActions,
} from '../../../../../resource/resources/artifacts/process_area/processAreaResource';
import { EditChildBaseDialog } from '../../../../reusable-components/dialogs/EditChildBaseDialog';
import { Form_DisplayComponentBaseView } from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { creationDialogOnSuccess } from '../../../../util/utilFunctions';
import { ProcessAreaContent } from './ProcessAreaContent';

export const ProcessAreaCreationDialog = ({
    onClose,
    parentId,
    autoGeneratedProps,
    onCreated,
}: {
    onClose: () => void;
    parentId: string;
    autoGeneratedProps?: ProcessAreaResource;
    onCreated?: (id: string, objectId: string) => void;
}) => {
    const processAreaActions = useProcessAreaActions();
    const addProcessArea = processAreaActions.useAddResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: ProcessAreaMutationResourceSchema,
        defaultValues: {
            ...defaultProcessAreaResource,
            ...autoGeneratedProps,
        },
        submitHandler: async (data) => {
            await addProcessArea.mutateAsync(
                {
                    resource: data,
                    parentId,
                },
                {
                    onSuccess: creationDialogOnSuccess(onCreated, onClose),
                }
            );
        },
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Create Process Area'}
            resourceType={ResourceType.PROCESS_AREA}
        >
            <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={true}>
                <ProcessAreaContent form={form} formNames={formNames} readOnly={false} />
            </Form_DisplayComponentBaseView>
        </EditChildBaseDialog>
    );
};
